export default "__VITE_ASSET__O6pvt4i5__"